export const GET_BETA_STATION= 'GET_BETA_STATION';
export const GET_BETA_STATION_SUCCESS = 'GET_BETA_STATION_SUCCESS';

